import { createSlice } from '@reduxjs/toolkit';
import { defaultExtendQuoteSlice } from './extendQuote.types';
import { extendQuoteByCatalogId, extendQuoteByInvoiceId } from './extendQuote.actions';

const extendQuoteSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(extendQuoteByCatalogId.pending, (slice) => {
            slice.catalog.error = '';
            slice.catalog.loading = true;
            slice.catalog.success = false;
        });
        builder.addCase(extendQuoteByCatalogId.fulfilled, (slice) => {
            slice.catalog.error = '';
            slice.catalog.loading = false;
            slice.catalog.success = true;
        });
        builder.addCase(extendQuoteByCatalogId.rejected, (slice, { payload }) => {
            slice.catalog.error = payload || 'An error occurred';
            slice.catalog.loading = false;
            slice.catalog.success = false;
        });

        builder.addCase(extendQuoteByInvoiceId.pending, (slice) => {
            slice.invoice.error = '';
            slice.invoice.loading = true;
            slice.invoice.success = false;
        });
        builder.addCase(extendQuoteByInvoiceId.fulfilled, (slice) => {
            slice.invoice.error = '';
            slice.invoice.loading = false;
            slice.invoice.success = true;
        });
        builder.addCase(extendQuoteByInvoiceId.rejected, (slice, { payload }) => {
            slice.invoice.error = payload || 'An error occurred';
            slice.invoice.loading = false;
            slice.invoice.success = false;
        });
    },
    initialState: defaultExtendQuoteSlice,
    name: 'extendQuoteSlice',
    reducers: {},
});

export const { reducer: extendQuoteReducer } = extendQuoteSlice;
